import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {SharedImports} from '@shared/shared-imports';
import {PrefillRegistrationModel, RegistrationRatesModel} from '@app/models/user-registration.model';

@Component({
  selector: 'app-rapid-registration-page-4',
  templateUrl: './registration-page-4-confirm.component.html',
  styleUrls: ['./registration-page-4-confirm.component.scss'],
  imports: [
    SharedImports
  ]
})

export class RegistrationPage4ConfirmComponent implements OnInit, OnChanges {
  @Output() next = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Input() personPrefill: PrefillRegistrationModel;
  @Input() registrationPrefillRates: RegistrationRatesModel[];
  totalPayment: number = 0;

  constructor(private router: Router, private location: Location) {
  }

  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.registrationPrefillRates && this.registrationPrefillRates) {
      this.registrationPrefillRates.forEach(r => {
        this.totalPayment = this.totalPayment + r.Amount;
      });
    }
  }

  goToNextPage() {
    this.next.emit();
  }

  login() {
    const baseUrl = window.location.href.replace(this.router.url, '');
    window.open(baseUrl + '/login', '_blank');
  }

  goBack() {
    this.location.back();
  }
}

